export default function getResource(label) {
    const resources = {
        onlyAFewLeft: 'IL N’EN RESTE QUE QUELQUES-UNS'
    };
    return resources[label];
}
